module.exports = __webpack_public_path__ + "img/sequence-miyashita-park-sp@2x.8de16072.jpg";